import { render, staticRenderFns } from "./ad-top.vue?vue&type=template&id=704540b3&scoped=true&"
import script from "./ad-top.vue?vue&type=script&lang=js&"
export * from "./ad-top.vue?vue&type=script&lang=js&"
import style0 from "./ad-top.vue?vue&type=style&index=0&id=704540b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704540b3",
  null
  
)

export default component.exports